export const firebaseConfig = {
    apiKey: "AIzaSyAcI4gns2Wjug60RYR9bza15oeV2GSn3Sc",
    authDomain: "donorflow-v1-live.firebaseapp.com",
    databaseURL: "https://donorflow-v1-live.firebaseio.com",
    projectId: "donorflow-v1-live",
    storageBucket: "donorflow-v1-live.appspot.com",
    messagingSenderId: "521350199644",
    appId: "1:521350199644:web:6ca0c7f23d49e5383de999",
    measurementId: "G-HRFJ3EVEWQ",
};

export const authAPI = "https://hi.donorflow.net/api"